import { useTranslations } from "use-intl";
import Text from "@/shared/typography/text";

const ABILITIES = [
  "ASSISTANT_ABILITY_REQUESTS",
  "ASSISTANT_ABILITY_APPROVALS",
  "ASSISTANT_ABILITY_TASKS",
  "ASSISTANT_ABILITY_DATA",
  "ASSISTANT_ABILITY_DOCUMENTS",
] as const;

/** Что ассистент умеет — по инструментам, которые ему доступны. */
export function AssistantAbilities() {
  const t = useTranslations("AI");

  return (
    <div className={"grid gap-3"}>
      <Text type={"body2"}>{t("ASSISTANT_ABILITIES_DESCRIPTION")}</Text>

      <ul className={"list-disc pl-5 grid gap-1"}>
        {ABILITIES.map((ability) => (
          <Text key={ability} as={"li"} type={"body2"}>
            {t(ability)}
          </Text>
        ))}
      </ul>

      <Text type={"body3"} color={"secondary"}>
        {t("ASSISTANT_ABILITIES_HINT")}
      </Text>
    </div>
  );
}
